import { FormEvent, useRef, useState } from 'react';
import logo from '../../Image/Logo.png';
import { nativeRequest } from './nativeBridge';
import './BroadcastLogin.css';

export default function BroadcastLogin() {
  const [userid, setUserid] = useState('');
  const [userpw, setUserpw] = useState('');
  const [autoLogin, setAutoLogin] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submitting = useRef(false);
  const login = async (event: FormEvent) => {
    event.preventDefault();
    if (submitting.current) return;
    submitting.current = true; setBusy(true); setError('');
    try { await nativeRequest('login', { userid: userid.trim(), userpw, autoLogin }); setUserpw(''); }
    catch (failure) { setError((failure as Error).message); }
    finally { submitting.current = false; setBusy(false); }
  };
  return <main className="broadcast-login">
    <form onSubmit={login}>
      <img src={logo} alt="Fanbird" />
      <h1>송출 앱 로그인</h1>
      <label htmlFor="broadcast-userid">아이디</label>
      <input id="broadcast-userid" autoComplete="username" autoCapitalize="none" spellCheck={false} maxLength={254} required
        value={userid} onChange={event => setUserid(event.target.value)} />
      <label htmlFor="broadcast-userpw">비밀번호</label>
      <input id="broadcast-userpw" type="password" autoComplete="current-password" maxLength={512} required
        value={userpw} onChange={event => setUserpw(event.target.value)} aria-describedby={error ? 'broadcast-login-error' : undefined} />
      <label className="broadcast-login__remember"><input type="checkbox" checked={autoLogin} onChange={event => setAutoLogin(event.target.checked)} />자동 로그인</label>
      {error && <p id="broadcast-login-error" role="alert">{error}</p>}
      <button type="submit" disabled={busy}>{busy ? '로그인 중…' : '로그인'}</button>
    </form>
  </main>;
}
